import React, { useState } from 'react';
import { Desktop, Tablet } from '../../constants/responsive';
import { css } from '@emotion/core';
import ShowAndHideTransition from '../ShowAndHideTransition';
import { FormattedHTMLMessage, useIntl } from 'gatsby-plugin-intl';
import { useLocation } from '@reach/router';
import '../../styles/sgu-details-question.scss';

const SGUQuestion = ({ name, title, answer }) => {
  const [showAnswer, setShowAnswer] = useState(false);
  const intl = useIntl();
  const location = useLocation();
  const isBespoke = location.pathname.split('/')[4] === 'bespoke';
  const iconPre = isBespoke ? 'bespoke-' : '';
  return (
    <div
      css={css`
        background: #ffffff;
        box-shadow: 0px 3px 60px 1px rgba(233, 233, 233, 0.8);
        border-radius: 15px;
        padding: 21px 15px;
        margin-bottom: 10px;
        ${Tablet} {
          border-radius: 8px;
          padding: 20px;
          margin-bottom: 20px;
        }
      `}
    >
      {/* title */}
      <div
        css={css`
          display: flex;
          justify-content: space-between;
          font-size: 16px;
          line-height: 18px;
          font-weight: 500;
          cursor: pointer;
          ${Tablet} {
            align-items: center;
            font-size: 18px;
            line-height: 33px;
          }
          ${Desktop} {
            font-size: 24px;
            line-height: 33px;
          }
        `}
        onClick={() => {
          setShowAnswer(!showAnswer);
        }}
      >
        <span>
          {title ||
            intl.formatMessage({
              id: `productDetails.pid-56.questions.${name}.title`,
            })}
        </span>
        <div
          css={css`
            display: flex;
            align-items: center;
            height: 18px;
            ${Tablet} {
              height: 33px;
            }
          `}
        >
          {showAnswer ? (
            <img className='icon-minus' src={`/icon/${iconPre}minus.png`}></img>
          ) : (
            <img className='icon-plus' src={`/icon/${iconPre}plus.png`}></img>
          )}
        </div>
      </div>
      {/* answer */}
      <ShowAndHideTransition show={showAnswer}>
        <div
          css={css`
            padding-top: 12px;
            overflow: hidden;
            font-size: 14px;
            line-height: 20px;
            a,
            a:active,
            a:visited {
              color: #ee2f79;
            }
            ${Tablet} {
              padding-top: 16px;
              font-size: 14px;
              line-height: 19px;
            }
            ${Desktop} {
              font-size: 20px;
              line-height: 30px;
              padding-bottom: 10px;
            }
          `}
        >
          {answer || (
            <FormattedHTMLMessage
              id={`productDetails.pid-56.questions.${name}.answer`}
            />
          )}
        </div>
      </ShowAndHideTransition>
    </div>
  );
};
export default SGUQuestion;
